<template>


  <div class="sw-game-list">
    <el-dropdown style="text-align: right;margin-top: 10px;margin-right: 10px;padding: 10px" @command="returnLogin">
      <div style="cursor: pointer; display: flex; align-items: flex-end;float: right;margin-right: 10px">
        <img src="../assets/images/mine.png" alt="" style="padding-top: 4px;padding-right: 10px">
        <span style="color: skyblue; font-size: 25px">{{ $store.state.userInfo.realname || '朱其坤' }}</span>
      </div>
      <el-dropdown-menu slot="dropdown"
                        style="background-color: #fff;cursor: pointer;color: #2ecbff;margin-top: 80px;width: 80px;padding: 10px;margin-right: 87px">
        <el-dropdown-item command="2">退出登录</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <div class="sw-game-list-container">
      <sw-button class="sw-btn-lang" :sound="false">{{ $route.query.name }}</sw-button>
      <div class="sw-game-list-box">
        <dl v-for="(item, index) of appList" :key="item.lxid" @click="selectType(item, index)"
            :style="{'width': $route.query.id == 2 ?'33.3%' : '25%'}">
          <dt>
            <img class="img" :src="require(`../assets/images/gamelist${$route.query.id}${index+1}.png`)"/>
          </dt>
          <dd class="sw-text">{{ item.lxmc }}</dd>
        </dl>
      </div>
    </div>


    <div style="position: absolute;bottom: 100px;right: 50px;cursor: pointer;display: flex;flex-direction: column;justify-content: center;align-items: center" @click="lookImg">
      <svg-icon :icon="'icon16'"/>
      <span>眼部训练</span>
    </div>
    <transition v-show="visible" name="fade" class="fadeclass">
    <div class="demo-image__preview" v-if="!flag">
        <span class="left" @click="left">
          <svg-icon :icon="'icon17'"/>
        </span>
      <span class="right" @click="right">
          <svg-icon :icon="'icon18'"/>
        </span>
      <span class="close" @click="close">
         <svg-icon :icon="'icon19'"/>
        </span>
      <img class="el-image" :src="imgUrl" alt="">
    </div>
    </transition>
  </div>
</template>

<script>
import {readType} from '@/api/reading'

export default {
  data() {
    return {
      visible: false,
      backOut: false,
      appList: [],
      index:0,
      flag:true,
      srcList: [
        'https://pk-words.oss-cn-shanghai.aliyuncs.com/vision/视觉训练1.gif',
        'https://pk-words.oss-cn-shanghai.aliyuncs.com/vision/视觉训练2.gif',
        'https://pk-words.oss-cn-shanghai.aliyuncs.com/vision/视觉训练3.gif',
        'https://pk-words.oss-cn-shanghai.aliyuncs.com/vision/视觉训练4.gif',
        'https://pk-words.oss-cn-shanghai.aliyuncs.com/vision/视觉训练5.gif',
        'https://pk-words.oss-cn-shanghai.aliyuncs.com/vision/视觉训练6.gif',
        'https://pk-words.oss-cn-shanghai.aliyuncs.com/vision/视觉训练7.gif',
        'https://pk-words.oss-cn-shanghai.aliyuncs.com/vision/视觉训练8.gif',
        'https://pk-words.oss-cn-shanghai.aliyuncs.com/vision/视觉训练9.gif',
        'https://pk-words.oss-cn-shanghai.aliyuncs.com/vision/视觉训练10.gif',
        'https://pk-words.oss-cn-shanghai.aliyuncs.com/vision/视觉训练11.gif',
        'https://pk-words.oss-cn-shanghai.aliyuncs.com/vision/视觉训练12.gif',
        'https://pk-words.oss-cn-shanghai.aliyuncs.com/vision/视觉训练13.gif',
        'https://pk-words.oss-cn-shanghai.aliyuncs.com/vision/视觉训练14.gif',
        'https://pk-words.oss-cn-shanghai.aliyuncs.com/vision/视觉训练15.gif',
        'https://pk-words.oss-cn-shanghai.aliyuncs.com/vision/视觉训练16.gif',
        'https://pk-words.oss-cn-shanghai.aliyuncs.com/vision/视觉训练17.gif',
        'https://pk-words.oss-cn-shanghai.aliyuncs.com/vision/视觉训练18.gif',
        'https://pk-words.oss-cn-shanghai.aliyuncs.com/vision/视觉训练19.gif',
        'https://pk-words.oss-cn-shanghai.aliyuncs.com/vision/视觉训练20.gif',
      ],
      imgUrl:'',
    };
  },
  created() {
    this.queryType()
    this.$store.commit('speedReading/setCurrentCheckPoint', '');
    window.localStorage.removeItem('instantaneous-currentCheckPoint');
  },
  methods: {
    async queryType() {
      let retryCount = 0;
      const maxRetries = 3; // 最大重试次数

      const fetchWithRetry = async () => {
        try {
          const {result} = await readType();
          this.appList = result;
        } catch (error) {
          console.error("Failed to fetch data:", error);

          if (retryCount < maxRetries) {
            retryCount++;
            console.log(`Retrying request, attempt ${retryCount}`);
            await fetchWithRetry(); // 递归调用以重试
          } else {
            console.error("Max retries reached. Unable to fetch data.");
          }
        }
      };
      await fetchWithRetry();
    },
    selectType(item, index) {
      console.log(item, '取用类型id')
      const appPath = item.lxmc === '能力测试'
          ? 'speedReading/evaluation'
          : item.lxmc === '阅读训练'
              ? 'speedReading/training'
              : item.lxmc === '必读书籍'
                  ? 'speedReading/training'
                  : '';

      if (appPath) {
        this.$router.push({
          path: '/sw/home',
          query: {
            app: appPath,
            lxid: item.lxid,
            lxmc: item.lxmc
          }
        });
      }

    },
    handleLoginOut() {
      this.$router.push("/sw/login");
    },
    returnLogin() {
      this.$router.replace({name: 'login'})
    },
    //  ------------------ 去做眼部训练
    lookImg(){
      this.randomImg()
      this.flag = false
    },
    //  --------------------退出眼部训练
    close(){
      this.flag = true
    },
    //  --------------------------左右切换
    left(){
      this.randomImg()
    },
    right(){
      this.randomImg()
    },
    //  -----------------------------随机展示图片
    randomImg(){
      this.index = Math.floor(Math.random() * 19) + 1
      this.imgUrl = this.srcList[this.index]
    }
  }
};
</script>

<style lang="scss">
.demo-image__preview{
  position: absolute;
  top: 5%;
  left: 5%;
  right: 5%;
  bottom: 5%;
  z-index: 5002;
  span{
    display: block;
    width: 44px;
    height: 44px;
    color: #fff;
    background-color: #606266;
    border-color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    opacity: .8;
    cursor: pointer;
    box-sizing: border-box;
  }
  .left{
    position: absolute;
    top: 50%;
    left: 0;
  }
  .right{
    position: absolute;
    top: 50%;
    right: 0;
  }
  .close{
    position: absolute;
    top: 0;
    right: 0;
  }
}
.el-image{
  display: block;
  width: 80vw;
  height: 40vw;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

}

</style>
